import { Component, OnInit } from '@angular/core';
import Utils from '@src/app/helpers/Utils';

@Component({
    selector: 'app-userdata',
    templateUrl: './userdata.component.html',
    styleUrls: ['./userdata.component.css'],
    standalone: false
})
export class UserdataComponent implements OnInit {

  public bookTypeFr : boolean;
  public bookTypeKbw : boolean;
  constructor() { }

  ngOnInit() {
    this.bookTypeFr = Utils.getBookType() == 'SKFRDriver';
    this.bookTypeKbw = Utils.getBookType() == 'KBW';
  }

}
